/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ManualCancelPolicyRiskDto } from './ManualCancelPolicyRiskDto';
export type ManualCancelPolicyDto = {
    /**
     * Cancellation reason
     */
    reason: ManualCancelPolicyDto.reason;
    /**
     * Additional cancellation context
     */
    reasonDetails?: string;
    /**
     * Effective cancellation date
     */
    effectiveCancellationDate: string;
    /**
     * Admin fee exclusive of GST; GST is added on top. Positive values are charged to the client, negative values are refunded.
     */
    adminFee: number;
    /**
     * Cancellation values for every active risk on the policy
     */
    risks: Array<ManualCancelPolicyRiskDto>;
    /**
     * Optional adviser notes for the cancellation
     */
    notes?: string;
};
export namespace ManualCancelPolicyDto {
    /**
     * Cancellation reason
     */
    export enum reason {
        POLICY_CANCELLED_BROKER_LOST_ACCOUNT = 'POLICY CANCELLED - BROKER LOST ACCOUNT',
        POLICY_CANCELLED_CANCELLED_BY_ANDO = 'POLICY CANCELLED - CANCELLED BY ANDO',
        POLICY_CANCELLED_FREE_LOOK = 'POLICY CANCELLED - FREE-LOOK',
        POLICY_CANCELLED_INSURED_ELSEWHERE = 'POLICY CANCELLED - INSURED ELSEWHERE',
        POLICY_CANCELLED_ISSUED_IN_ERROR = 'POLICY CANCELLED - ISSUED IN ERROR',
        POLICY_CANCELLED_NON_PAYMENT_OF_PREMIUM = 'POLICY CANCELLED - NON-PAYMENT OF PREMIUM',
        POLICY_CANCELLED_NOT_HAPPY_WITH_SERVICE = 'POLICY CANCELLED - NOT HAPPY WITH SERVICE',
        POLICY_CANCELLED_NOT_REQUIRED = 'POLICY CANCELLED - NOT REQUIRED',
        POLICY_CANCELLED_REASON_UNKNOWN = 'POLICY CANCELLED - REASON UNKNOWN',
        POLICY_CANCELLED_REPLACED = 'POLICY CANCELLED - REPLACED',
        POLICY_CANCELLED_SOLD = 'POLICY CANCELLED - SOLD',
        POLICY_CANCELLED_TOTAL_LOSS = 'POLICY CANCELLED - TOTAL LOSS',
    }
}

